(ns frontend.view.components.power-search.results.view
  (:require
   [clojure.string :as string]
   [common.entity :as entity]
   [common.localization :as loc]
   [common.schema.entity-type-names :as entity-type-names]
   [common.util :as cu]
   [frontend.utils :as fu]
   [frontend.view.components.power-search.event :as event]
   [frontend.view.components.power-search.hit.view :as hit-component]
   [frontend.view.components.power-search.key-hint.view :as key-hint]
   [frontend.view.components.power-search.no-results.view :as no-results]
   [frontend.view.components.power-search.recents.view :as recents]
   [frontend.view.components.power-search.sub :as sub]
   [oops.core :as oops]
   [re-frame.core :as rf]
   [reagent.core :as r]
   [ui.components.button.view :as button]
   [ui.components.radix-ui.tooltip.view :as tooltip]
   [ui.dom-globals :as dg]))

(defn results
  []
  (let [on-key-down (fn [e] (when (= "Escape" (dg/event-key e))
                              (rf/dispatch [::event/esc])))]
    (r/create-class
     {:display-name           "results"
      :component-did-mount    (fn []
                                (.addEventListener (dg/body) "keydown" on-key-down)
                                (rf/dispatch [::event/cleanup-deleted-results]))
      :component-will-unmount (fn []
                                (.removeEventListener (dg/body) "keydown" on-key-down))
      :reagent-render
      (fn []
        (let [main-view-entity-type->hits @(rf/subscribe [::sub/main-view-hits-by-entity-type])
              loading? @(rf/subscribe [::sub/loading?])
              type-view-entity-type @(rf/subscribe [::sub/type-view-entity-type])
              type-view? (boolean type-view-entity-type)
              type-view-hits @(rf/subscribe [::sub/type-view-hits])
              total-hits @(rf/subscribe [::sub/type-view-total-hits])
              show-loading-text? @(rf/subscribe [::sub/show-loading-text?])
              entity-type->hits (if type-view?
                                  {type-view-entity-type type-view-hits}
                                  main-view-entity-type->hits)
              query @(rf/subscribe [::sub/query])
              no-results? (->> entity-type->hits                                                    ;; TODO : I'm not sure if I like that we expose the OpenSearch results directly to client -> I think it would be better for us to do cleanup on server side
                               (vals)
                               (map count)
                               (reduce +)
                               (= 0)
                               (or (empty? query)))
              input-focused? @(rf/subscribe [::sub/input-focused?])]
          [:div
           {:class "w-full h-full px-6 fixed top-0 left-0 flex justify-center items-center bg-black/[.1] z-[60000]"}
           [:div
            {:class    "relative z-[60001] md:w-[896px] max-w-full flex flex-col shadow bg-base-light rounded max-h-screen"
             :on-click dg/stop-propagation}
            [:div
             {:class "py-3 flex justify-between border border-solid border-base-light-border-paler relative"}
             [:div
              {:class "m-0 flex items-center absolute left-3 top-4 text-md"}
              [:i.fal.fa-search]]
             [:input
              {:id          "universalSearchInput"
               :class       "w-full pl-10 border-none focus:outline-none focus:shadow-none"
               :tab-index   998
               :placeholder (loc/tr :enter-search-query-to-see-results)
               :auto-focus  true
               :on-focus    (fn [e]
                              (let [target (dg/target e)]
                                (oops/oset! target "autocomplete" "off")
                                (rf/dispatch [::event/set-input-focused? true])))
               :on-blur     (fn []
                              (rf/dispatch [::event/set-input-focused? false]))
               :on-change   (fn [e]
                              (rf/dispatch [::event/query-change (dg/event-target-value e)]))
               :on-key-down (fn [e]
                              (when (= "Enter" (dg/event-key e))
                                (rf/dispatch [::event/select-first-result])))
               :on-click    dg/stop-propagation}]
             [:div
              {:class "pr-3 flex gap-2 items-center *:p-0"}
              [key-hint/key-hint {:small? true} (loc/tr :shortcut-esc)]
              [button/secondary-open
               {:on-click (fn [] (rf/dispatch [::event/close]))}
               [:i.fal.fa-times]]]]
            [:div
             {:class "flex-1 overflow-auto"}
             [:div
              {:class "min-h-[440px] flex gap-3"}
              [:div
               {:class "flex-1"}
               (when-not (cu/blank-value? query)
                 [:div
                  {:class "flex shrink-0 grow-0 flex-row justify-center"}
                  [:span
                   {:class "m-2 p-4 bg-info-light text-info-light-text flex flex-row items-center gap-2"}
                   (loc/tr :search-fuzzy-info)
                   [tooltip/view
                    [:i.fal.fa-question-circle.text-info-light-text]
                    [:span
                     {:class "block max-w-60 w-60"}
                     (loc/tr :search-fuzzy-info-tooltip)]]]])
               (when type-view?
                 [:div
                  {:class "pt-2 px-4"}
                  [:div
                   {:class "w-auto inline-flex px-3 items-center gap-2 rounded-full border border-solid border-base-light-border-paler bg-complement-regular"}
                   [:div
                    "Type"]
                   [:div
                    (loc/tr :filter-operator-is)]
                   [:div
                    (string/lower-case (entity-type-names/get-name type-view-entity-type :en))]
                   [button/secondary-open
                    {:tab-index   999
                     :on-key-down (fn [e] (when (= "Enter" (dg/event-key e))
                                            (dg/stop-propagation e)))                                ;; TODO used more than once, maybe a helper function -  fu/stop-enter ? or something like that ?
                     :on-click    (fn [] (rf/dispatch [::event/close-type-view]))}
                    [:i.fal.fa-times]]]])
               [:div
                {:id    "universalSearchScrollContainer"
                 :style (when loading? {:opacity 0.2})}
                (if no-results?
                  (if show-loading-text?
                    [:div
                     (loc/tr :loading-indicator)]
                    [no-results/no-results])
                  [:div
                   {:class "flex flex-col gap-6 p-4"}
                   (->>
                    entity-type->hits
                    (map-indexed
                     (fn [section-index [entity-type hits]]
                       (let [entity-type-display-name (entity-type-names/get-plural entity-type :en)
                             more? (boolean (get hits 4))
                             can-load-more? (and type-view?
                                                 (> total-hits (count hits)))
                             visible-hits (if-not type-view?
                                            (take 4 hits)
                                            hits)]
                         ^{:key entity-type}
                         [:div
                          {:class "flex flex-col gap-2"}
                          [:div
                           {:class "flex gap-3 justify-between items-center"}
                           [:div
                            {:class "flex items-center gap-2"}
                            [:span
                             {:class "flex w-8 h-8 justify-center items-center rounded-full bg-complement-regular"}
                             [:i
                              {:class-name (->> entity-type
                                                (entity/entity-type-icon)
                                                (fu/cs "inline-block text-md" :fal))}]]
                            [:b entity-type-display-name]]
                           [:div
                            #_(str "("
                                   (if type-view? (count hits) (min (count hits) 4))
                                   " "
                                   (loc/tr :of)
                                   " "
                                   (if type-view? total-hits total-count)
                                   ")")]
                           (when more?
                             [:div
                              {:class "*:p-0"}
                              [button/primary-open
                               {:tab-index   -1
                                :on-key-down (fn [e] (when (= "Enter" (dg/event-key e))
                                                       (dg/stop-propagation e)))
                                :on-click    (fn []
                                               (let [dom-input (dg/element-by-id "universalSearchInput")]
                                                 (if dom-input
                                                   (.focus dom-input)
                                                   (js/console.log "Cannot find universal search input!"))
                                                 (rf/dispatch [::event/open-type-view
                                                               entity-type])))}
                               (str (loc/tr :show-only-entity-type)
                                    (string/lower-case entity-type-display-name))]])]
                          [:<>
                           [:div
                            {:class "flex flex-col gap-2 pl-8"}
                            (->> visible-hits
                                 (map-indexed
                                  (fn [hit-index hit]
                                    ^{:key (:_id hit)}
                                    [hit-component/hit
                                     {:hit       hit
                                      :tab-index (-> section-index
                                                     (* 100)
                                                     (+ hit-index)
                                                     (+ 1000))
                                      :active?   (and (= 0 section-index)
                                                      (= 0 hit-index)
                                                      input-focused?)}])))]
                           (when can-load-more?
                             [button/secondary-open
                              {:tab-index   (-> section-index
                                                (* 100)
                                                (+ (count visible-hits))
                                                (+ 1000))
                               :on-key-down (fn [e] (when (= "Enter" (dg/event-key e))
                                                      (dg/stop-propagation e)))
                               :on-click    (fn []
                                              (rf/dispatch [::event/load-more]))}
                              (loc/tr :load-more)])]]))))])]]
              [recents/recents {:input-focused? input-focused?}]]]]]))})))
